import { useRouter } from 'next/router'

export const useAuthParams = () => {
  const router = useRouter()

  const storeUrlParams = async () => {
    const urlParams = new URLSearchParams(window.location.search)
    const paramsObject = Object.fromEntries(urlParams.entries())

    if (Object.keys(paramsObject).length > 0) {
      await localStorage.setItem('authParams', JSON.stringify(paramsObject))
    } else {
      console.log('removing authParams')
      localStorage.removeItem('authParams')
    }
  }

  const redirectWithExistingParams = (url: string) => {
    const authParams = localStorage.getItem('authParams')
    if (authParams) {
      const params = JSON.parse(authParams)
      const paramsString = Object.keys(params).reduce((acc, key) => {
        acc += `${key}=${params[key]}&`
        return acc
      }, '?')
      router.push(`${url}${paramsString}`)
      return
    }

    router.push(url)
  }

  const getAuthParams = () => {
    const authParams = localStorage.getItem('authParams')
    if (authParams) {
      return JSON.parse(authParams)
    }
    return null
  }

  const clearAuthParams = () => {
    // localStorage.removeItem('authParams')
  }

  return {
    storeUrlParams,
    redirectWithExistingParams,
    getAuthParams,
    clearAuthParams,
  }
}
